import type { BillingInterval } from "../services/accountService";

/**
 * Format a price in cents to a localized currency string.
 * ISO 4217 currency code display per project convention (.claude/rules/frontend/currency-formatting.md).
 */
export function formatCurrency(cents: number, currency: string): string {
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency,
    currencyDisplay: "code",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}

/**
 * Format a price in cents as a whole-unit currency string (rounded, no decimals), e.g. "99 PLN".
 * Used for indicative catalog prices (`metadata.priceMonthly`); exact amounts use `formatCurrency`.
 */
export function formatCurrencyWhole(cents: number, currency: string): string {
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency,
    currencyDisplay: "code",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function formatDate(dateString: string | null): string {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("pl-PL", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

const BILLING_INTERVAL_LABELS: Record<BillingInterval, string> = {
  monthly: "miesięcznie",
  quarterly: "kwartalnie",
  yearly: "rocznie",
};

export function getBillingIntervalLabel(interval: BillingInterval): string {
  return BILLING_INTERVAL_LABELS[interval] || interval;
}
